.embed-container {
  background-color: var(--palette-background-primary);
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='48' height='48' fill='%23757575' viewBox='0 0 960 960'%3E%3Cpath d='M234 940q-48 0-81-33t-33-81q0-48 33-81t81-33q14 0 25 3l21 7 85-106q-19-23-29-52t-5-62l-121-41q-15 25-39 39t-57 14q-48 0-81-33T0 400q0-48 33-81t81-33q48 0 81 33t33 81v4l122 42q18-32 44-49t56-24V244q-39-11-61-43t-23-67q0-48 33-81t81-33q48 0 81 33t33 81q0 35-23 67t-61 43v129q31 7 57 24t44 49l121-42v-4q0-48 33-81t81-33q48 0 81 33t33 81q0 48-33 81t-81 33q-32 0-57-14t-39-39l-121 41q5 32-4 62t-30 52l85 106q11-5 22-7l24-3q48 0 81 33t33 81q0 48-33 81t-81 33q-48 0-81-33t-33-81q0-20 6-36t15-31l-85-106q-32 17-68 17t-69-17l-84 107q10 15 16 31t5 35q0 48-33 81t-81 33z'/%3E%3C/svg%3E");
  background-position: center;
  background-repeat: no-repeat;
  display: grid;
  height: 200px;
  interpolate-size: allow-keywords;
  margin: 15px 0;
  min-height: 200px;
  overflow: clip;
  pointer-events: none;
  position: relative;
  transition: height 0.5s ease;

  @include use-desktop-device {
    height: 250px;
    min-height: 250px;
  }

  &[data-shall-expand='true'] {
    height: auto;
    pointer-events: auto;

    @supports (height: calc-size(auto, size)) {
      height: calc-size(auto, size);
    }
  }

  & > * {
    margin: auto 0;
  }

  iframe {
    background-color: var(--palette-background-primary);
  }
}

.embed-container-expand-content {
  align-items: flex-end;
  background: linear-gradient(0deg,
      var(--palette-background-primary) 0%,
      transparent 100%);
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  margin: 0;
  pointer-events: none;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 49;

  &__button {
    align-items: center;
    appearance: none;
    background-color: var(--palette-accent-primary);
    border: 0;
    color: var(--palette-accent-primary-contra);
    cursor: pointer;
    display: flex;
    font: use-font-secondary("700 12px/18px");
    gap: 4px;
    height: 30px;
    padding: 8px 10px;
    pointer-events: auto;
    text-transform: uppercase;
    transform: translateY(-1px);

    &:focus {
      outline: 1px solid var(--palette-foreground-primary);
    }

    & > svg {
      display: block;
      font-size: 0;
      line-height: 0;
    }
  }
}

.embed-container-cookie-screen {
  align-items: center;
  background-color: var(--palette-background-primary);
  display: flex;
  flex-flow: column nowrap;
  gap: 20px;
  height: 200px;
  justify-content: center;
  z-index: 10;

  @include use-desktop-device {
    height: 250px;
  }

  &__icon {
    display: block;
    height: 24px;
    margin: 0 auto;
    width: 24px;

    &::before {
      content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='%23757575' viewBox='0 0 960 960'%3E%3Cpath d='M480 960q-100 0-187-38-88-38-153-102-64-65-102-152Q0 580 0 481q0-90 35-177 35-86 97-154 62-67 150-109Q370 0 474 0l52 2q26 3 54 9-11 54 7 102t54 79q36 32 86 44 49 12 102-6-31 71 9 136 40 64 120 67l1 24 1 25q0 98-38 185T820 819q-65 65-153 103-87 38-187 38Zm-72-575q30 0 51-21t21-51q0-30-21-51t-51-21q-30 0-51 21t-21 51q0 30 21 51t51 21zm-96 239q30 0 51-21t21-50q0-30-21-51t-51-21q-30 0-51 21t-21 51q0 29 21 50t51 21zm312 48q20 0 34-13 14-14 14-35 0-20-14-34t-34-14q-20 0-34 14t-14 34q0 21 14 35 14 13 34 13z'/%3E%3C/svg%3E");
      display: block;
      font-size: 0;
      line-height: 0;
    }
  }

  &__text {
    color: var(--palette-foreground-secondary);
    font: use-font("400 14px/18px");
    text-align: center;
  }

  &__button {
    align-items: center;
    appearance: none;
    background-color: var(--palette-accent-primary);
    border: 0;
    color: var(--palette-accent-primary-contra);
    cursor: pointer;
    display: flex;
    font: use-font-secondary("700 12px/18px");
    gap: 4px;
    height: 30px;
    padding: 8px 10px;
    pointer-events: auto;
    text-transform: uppercase;
    transform: translateY(-1px);

    &:focus {
      outline: 1px solid var(--palette-foreground-primary);
    }
  }
}